import Image from "next/image";
import { Fragment } from "react";
import Moment from "react-moment";
import { useContext } from "react";
import PoolContext from "@/seed/contexts/pool/pool-context";
import commonConstant from "@/constants/commonConstant";

const layoutContentDef = {
    star: {
        img: "/img/star@3x.webp",
        width: 252,
        height: 243,
    },
    starGlow: {
        img: "/img/star-glow@3x.webp",
        width: 252,
        height: 243,
    },
};

const CompleteStep = ({ completedStep }) => {
    const { saleEvent } = useContext(PoolContext);

    console.log("CompleteStep", { completedStep, saleEvent });

    if (!saleEvent || !saleEvent?.timeline) return <div>Loading</div>;

    const data = {
        steps: [
            {
                step: 1,
                title: "Upcoming",
                time: "",
            },
            {
                step: 2,
                title: "Whitelist Open",
                time: saleEvent.timeline.whitelistStart?.valueOf() ?? "",
            },
            {
                step: 3,
                title: "Sale Open",
                time: saleEvent.timeline.purchaseStart?.valueOf() ?? "",
            },
            {
                step: 4,
                title: "Close",
                time: "",
            },
        ],
    };
    return (
        <div className="flex flex-row justify-center items-start space-x-2 md:space-x-4">
            {data.steps.map((e, index) => {
                let imgData =
                    e.step <= completedStep ? layoutContentDef.starGlow : layoutContentDef.star;
                return (
                    <Fragment key={index.toString()}>
                        <div className="flex flex-col items-center justify-center space-y-2 w-12 md:w-24 lg:w-36">
                            <div className="w-20 md:w-32">
                                <Image
                                    src={imgData.img}
                                    width={imgData.width}
                                    height={imgData.height}
                                    layout="intrinsic"
                                />
                            </div>
                            <span className="uppercase font-secondary text-xs md:text-lg text-maize text-center">
                                {e.title}
                            </span>
                            {e.time ? (
                                <Moment
                                    className="font-secondary text-center text-xs md:text-sm"
                                    format={commonConstant.FORMAT_DATE_TIMEZONE}
                                    date={e.time}
                                />
                            ) : (
                                <></>
                            )}
                        </div>
                        <div
                            className={
                                index < data.steps.length - 1
                                    ? "w-8 md:w-20 border-t-[1px] border-white border-solid mt-[11%] md:mt-[8%] lg:mt-[7%]"
                                    : "hidden"
                            }
                        ></div>
                    </Fragment>
                );
            })}
        </div>
    );
};

export default CompleteStep;
//# sourceMappingURL=complete-step.js
